<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['events.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'EVENTS.EVENTS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['events.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'EVENTS.EVENTS_LIST.ADD' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="eventsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Events', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'EVENTS.EVENTS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'EVENTS.EVENTS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="event_group.name"
      title="{{ 'EVENTS.EVENTS_LIST.GROUP_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event_group.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-group-select [filter]="filter"></app-kendo-event-group-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/event-groups/view']" [queryParams]="{ id: dataItem?.event_group?.id }" target="_blank">
          {{ dataItem?.event_group?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'EVENTS.EVENTS_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem.formattedName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date_from"
      title="{{ 'EVENTS.EVENTS_LIST.DATE_FROM' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('date_from')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date_from | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date_to"
      title="{{ 'EVENTS.EVENTS_LIST.DATE_TO' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('date_to')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date_to | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="priority.value"
      title="{{ 'EVENTS.EVENTS_LIST.PRIORITY' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('priority.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'event_group_priorities'" [filter]="filter" [field]="'priority_id'">
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.priority"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="country_id"
      title="{{ 'EVENTS.EVENTS_LIST.COUNTRY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('country_id')"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-country-select [filter]="filter" [field]="'country_id'"></app-kendo-country-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <app-country-box
          *ngIf="dataItem?.venue?.city?.country || (dataItem?.venue?.city?.country && dataItem?.city?.country)"
          [country]="dataItem?.venue?.city?.country"
        >
        </app-country-box>

        <app-country-box
          *ngIf="dataItem?.city?.country && !dataItem?.venue?.city?.country"
          [country]="dataItem?.city?.country"
        ></app-country-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="city_excel_export"
      title="{{ 'EVENTS.EVENTS_LIST.CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city_id')"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter" [field]="'city_id'"></app-kendo-city-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.city?.name || dataItem?.venue?.city?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="industry.name"
      title="{{ 'EVENTS.EVENTS_LIST.INDUSTRY' | translate }}"
      filter="text"
      [hidden]="
        isHiddenColumn(
          'industry.name',
          accessService.hasAccess(
            [
              UserRoleType.RESERVATION_AGENT,
              UserRoleType.RESERVATION_MANAGER,
              UserRoleType.CONTRACTING_AGENT,
              UserRoleType.CONTRACTING_MANAGER,
              UserRoleType.SALES_AGENT,
              UserRoleType.SALES_MANAGER,
              UserRoleType.CUSTOMER_CARE_AGENT,
              UserRoleType.CUSTOMER_CARE_MANAGER,
              UserRoleType.FINANCE_AGENT,
              UserRoleType.FINANCE_MANAGER,
              UserRoleType.LEAD_GENERATION,
              UserRoleType.EXTERNAL_PARTNER_LEAD,
              UserRoleType.EXTERNAL_PARTNER
            ],
            []
          )
        )
      "
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-industry-select [filter]="filter"></app-kendo-industry-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="show_to_web"
      title="{{ 'EVENTS.EVENTS_LIST.SHOW_TO_WEB' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('show_to_web')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.show_to_web"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="active"
      title="{{ 'EVENTS.EVENTS_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.MARKETING,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="tags"
      title="{{ 'EVENTS.EVENTS_LIST.TAGS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('tags', accessService.hasAccess([UserRoleType.LEAD_GENERATION], []))"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-kendo-tag-select [filter]="filter" [model]="LaravelModels.EVENT"></app-kendo-tag-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span *ngFor="let tag of dataItem?.tags; let i = index">
          {{ tag }}<span *ngIf="i !== dataItem?.tags?.length - 1">, </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="venue.name"
      title="{{ 'EVENTS.EVENTS_LIST.VENUE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('venue.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-venue-select [filter]="filter"></app-kendo-venue-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="organizer"
      title="{{ 'EVENTS.EVENTS_LIST.ORGANIZER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('organizer', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="website_url"
      title="{{ 'EVENTS.EVENTS_LIST.WEBSITE_URL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('website_url', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="visitors"
      title="{{ 'EVENTS.EVENTS_LIST.VISITORS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('visitors')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="exhibitors"
      title="{{ 'EVENTS.EVENTS_LIST.EXHIBITORS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('exhibitors', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="foreign_exhibitors"
      title="{{ 'EVENTS.EVENTS_LIST.FOREIGN_EXHIBITORS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('foreign_exhibitors', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="link_exhibitors"
      title="{{ 'EVENTS.EVENTS_LIST.LINK_EXHIBITORS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('link_exhibitors', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="year_exhibitors"
      title="{{ 'EVENTS.EVENTS_LIST.YEAR_EXHIBITORS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('year_exhibitors', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="note"
      title="{{ 'EVENTS.EVENTS_LIST.NOTE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('note', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="type.value"
      title="{{ 'EVENTS.EVENTS_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'event'" [filter]="filter"></app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotel_bookings_count"
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.MARKETING,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      title="{{ 'EVENTS.EVENTS_LIST.BOOKINGS' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [width]="110"
      [hidden]="isHiddenColumn('hotel_bookings_count')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          [routerLink]="['/hotel-bookings']"
          [queryParams]="{ event_id: dataItem.id }"
          (click)="pushToStorage(dataItem)"
          (contextmenu)="pushToStorage(dataItem)"
        >
          {{ dataItem.hotel_bookings_count }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="enquiries_count"
      title="{{ 'EVENTS.EVENTS_LIST.ENQUIRIES_COUNT' | translate }}"
      [width]="70"
      [filterable]="false"
      [columnMenu]="false"
      [hidden]="isHiddenColumn('enquiries_count')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.MARKETING,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="adv_hotel_bookings_by_hotel_count"
      title="{{ 'EVENTS.EVENTS_LIST.ADV_HOTEL_BOOKINGS_BY_HOTEL_COUNT' | translate }}"
      [hidden]="
        isHiddenColumn('adv_hotel_bookings_by_hotel_count', accessService.hasAccess([UserRoleType.LEAD_GENERATION], []))
      "
      [width]="110"
      [filterable]="false"
      [sortable]="false"
    >
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="
        accessService.hasAccess(
          [
            UserRoleType.RESERVATION_AGENT,
            UserRoleType.RESERVATION_MANAGER,
            UserRoleType.CONTRACTING_AGENT,
            UserRoleType.CONTRACTING_MANAGER,
            UserRoleType.SALES_AGENT,
            UserRoleType.SALES_MANAGER,
            UserRoleType.CUSTOMER_CARE_AGENT,
            UserRoleType.CUSTOMER_CARE_MANAGER,
            UserRoleType.FINANCE_AGENT,
            UserRoleType.FINANCE_MANAGER,
            UserRoleType.LEAD_GENERATION,
            UserRoleType.MARKETING,
            UserRoleType.EXTERNAL_PARTNER_LEAD,
            UserRoleType.EXTERNAL_PARTNER
          ],
          []
        )
      "
      field="adv_hotel_bookings_rooms_count"
      title="{{ 'EVENTS.EVENTS_LIST.ADV_HOTEL_BOOKINGS_COUNT' | translate }}"
      [hidden]="
        isHiddenColumn('adv_hotel_bookings_rooms_count', accessService.hasAccess([UserRoleType.LEAD_GENERATION], []))
      "
      [width]="110"
      [filterable]="false"
      [sortable]="false"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'EVENTS.EVENTS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'EVENTS.EVENTS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD,
                UserRoleType.EXTERNAL_PARTNER
              ],
              ['events.show']
            )
          "
          [link]="['/events/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION, UserRoleType.MARKETING], ['events.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="
            accessService.hasAccess(
              [UserRoleType.IT, UserRoleType.MARKETING, UserRoleType.LEAD_GENERATION],
              ['events.translations']
            )
          "
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['events.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <app-links-compact-translates [data]="dataItem"> </app-links-compact-translates>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
